import { Typography } from "@mui/material";

import { useTheme } from "@mui/styles";
import React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  combineClassNames,
  getAdaptiveFontSize,
} from "../../utils/styling.utils";

const HeadlineText = ({ text = "", styles = {}, classNames = "" }) => {
  const theme = useTheme();
  //Media Queries
  const isSmartphoneScreen = useMediaQuery("(min-width: 0px)");
  const isSmallScreen = useMediaQuery("(min-width: 500px)");
  const isMediumScreen = useMediaQuery("(min-width: 768px)");
  const isLargeScreen = useMediaQuery("(min-width: 992px)");
  const isExtraLargeScreen = useMediaQuery("(min-width: 1200px)");
  const screenWidthHooks = {
    isSmartphoneScreen,
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isExtraLargeScreen,
  };

  const combinedClasses = combineClassNames("text-end", classNames);
  return (
    <Typography
      // className={combinedClasses}
      style={{
        fontSize: getAdaptiveFontSize({
          screenWidthHooks,
          fontSize: 4,
        }),
        textAlign: "end",
        opacity: 1,
        color: theme.COLORS.BLUE.darkBlueGreen,
        lineHeight: "0.75",
        marginTop: "-1rem",
        fontWeight: "bold",
        fontFamily: "elena-web-basic",
        ...styles,
      }}
    >
      {text}
    </Typography>
  );
};

export default HeadlineText;
